import React, { useState, useContext } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import Select from "react-select";
import { FiX, FiEdit } from "react-icons/fi";
import { Content, Container } from "./styles";
import QuestionContext from "../../contexts/QuestionContext";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { DocEditTypes } from "./types";

function DocEdit({ show, doc, sendTagChange }: DocEditTypes) {
	const [notification, setNotification] = useState<string>();
	const [notificationList, setNotificationList] = useState<string[]>([]);

	const [editName, setEditName] = useState(false);
	const [selectedTag, setSelectedTag] = useState<any>();

	const { tags } = useContext(QuestionContext);

	const customStyles = {
		option: (provided: any) => ({
			...provided,
			borderBottom: "1px solid #C0C4DF",
			fontSize: "1rem",
		}),
		placeholder: (provided: any) => ({
			...provided,
			fontSize: "1rem",
			color: "#C0C4DF",
		}),
		singleValue: (provided: any) => ({
			...provided,
			fontSize: "1rem",
			fontWeight: "600",
		}),
		control: (provided: any, state: any) => ({
			...provided,
			border: state.isFocused ? "1px solid #2D7BBC" : "1px solid #C0C4DF",
		}),
	};

	const handleChangeTag = () => {
		sendTagChange(selectedTag.id);

		show("hidden");
	};

	const removeNotification = (i: any) => {
		setNotificationList((state: any) => state.splice(i, 1));
	};

	const handleNewNotification = (e: any) => {
		e.preventDefault();

		// @ts-ignore
		setNotificationList([...notificationList, notification]);
	};

	const NotificationComp = ({ text, index }: any) => {
		return (
			<div className='notification-item'>
				<p>{text}</p>
				<button
					onClick={() => removeNotification(index)}
					className='remove_notification'>
					<FiX className='svg-icon' />
				</button>
			</div>
		);
	};

	return (
		<Container>
			<OutsideClickHandler onOutsideClick={() => show("hidden")}>
				<Content>
					<div className='doc-container'>
						<div className='header'>
							{editName === false &&
							doc.documentTag === undefined ? (
								<div
									className='edit-button '
									onClick={() => setEditName(!editName)}>
									<p>Vincular Tag</p>

									<FiEdit className='edit-docname' />
								</div>
							) : editName === false ? (
								<div
									className='edit-button'
									onClick={() => setEditName(!editName)}>
									<p>{doc.documentTag}</p>

									<FiEdit className='edit-docname' />
								</div>
							) : (
								<div className='edit-button'>
									<Select
										className='name-select'
										options={tags.map((tag: any) => ({
											label: tag.name,
											value: tag.id,
										}))}
										styles={customStyles}
										placeholder='Selecione o tipo de documento'
										onChange={(selectedOption) => {
											const selectedTag = {
												name: selectedOption,
												id: selectedOption!.value,
											};

											setSelectedTag(selectedTag);
										}}
									/>

									<FiEdit
										className='edit-docname'
										onClick={() => setEditName(!editName)}
									/>
								</div>
							)}
						</div>

						<div className='pages'>
							<iframe
								src={doc?.location || ""}
								frameBorder={0}
								title='docs_frame'></iframe>
						</div>
						<div className='buttons'>
							<button
								id='cancel-button'
								type='button'
								onClick={() => show("hidden")}>
								Cancelar
							</button>
							<button id='save-button' onClick={handleChangeTag}>
								Salvar
							</button>
						</div>
					</div>
					<div className='notification-container'>
						<div className='create-notification'>
							<form onSubmit={handleNewNotification}>
								<textarea
									className='text-area'
									placeholder='Max de 55 caracteres'
									onChange={(e) =>
										setNotification(e.target.value)
									}
									maxLength={55}
								/>

								<button className='create-button'>
									ADICIONAR AVISO
								</button>
							</form>
						</div>
						<div className='notification-division'></div>
						<div className='notification-wrapper'>
							<div className='notification-number'>
								<p>Avisos: {notificationList?.length}</p>
							</div>
							<div className='notification-content'>
								{notificationList?.map((item, index) => (
									<NotificationComp
										notification_text={item}
										key={index}
									/>
								))}
							</div>
						</div>
					</div>
				</Content>
			</OutsideClickHandler>
		</Container>
	);
}

export default DocEdit;
